import React, { useState } from "react";
import s from "../MainEducation.module.css";
import LessonAccordionTopComponent from "../Lessons/LessonAccordionTopComponent";
import EducationModules from "./EducationModules";

const EducationOneModuleElement = ({ title, link }) => {
  const [open, setOpen] = useState(false);
  return (
    <li className={s.lessonsListElement}>
      <LessonAccordionTopComponent
        title={title}
        open={open}
        setOpen={setOpen}
      />
      {open && (
        <div className={s.accordionContent}>
          <EducationModules link={link} />
        </div>
      )}
    </li>
  );
};

export default EducationOneModuleElement;
